export default __webpack_public_path__ + "static/media/agen_referral_cara4.6cf1a746.svg";